module.exports = __webpack_public_path__ + "img/BAO_HIEM.b7f7eb39.svg";